import type { Failure } from './api/schemas';
import { dayKey } from './dayHeading';

export interface FailureDay {
  key: string;
  date: Date;
  failures: Failure[];
}

/** Newest day first, and within a day the newest slot first: the list opens on what needs
 *  looking at now. */
export function groupFailuresByDay(failures: Failure[]): FailureDay[] {
  const days = new Map<string, FailureDay>();
  const newestFirst = [...failures].sort(
    (a, b) => new Date(b.scheduled_slot).getTime() - new Date(a.scheduled_slot).getTime(),
  );

  for (const failure of newestFirst) {
    const date = new Date(failure.scheduled_slot);
    const key = dayKey(date);
    const day = days.get(key) ?? { key, date, failures: [] };
    day.failures.push(failure);
    days.set(key, day);
  }

  return Array.from(days.values());
}
